import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter as Router, Link, Route } from 'react-router-dom'
import { apiHostname, build } from '../../config'
import { MainMenu, ReportExpandMenu } from '../../constants'
import { routes } from '../../routes'
import { authService } from '../../services'
import { localStorage, sessionStorage } from '../../util'

// UI
import { Button, SideModal } from '../../components'
import Icon from 'antd/lib/icon'

import Form from 'antd/lib/form'

import './styles.css'

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showMenu: false,
      showReportMenu: false,
      showUser: false
    }
  }

  componentDidMount () {
    const el = document.getElementById('root')
    el.addEventListener('click', this.handleAnyClick)
  }

  componentWillUnmount () {
    const el = document.getElementById('root')
    el.removeEventListener('click', this.handleAnyClick)
  }

  handleAnyClick = ({ target }) => {
    const { className } = target

    if (className.indexOf && (className.indexOf('hamburger') < 0)) {
      this.hideMenu()
      this.hideReportMenu()
    } else {
      // this.hideMenu()
    }

    /* console.log(e.target.outerHTML)
    if (!(e.target && e.target.outerHTML.includes('menu-popup'))) {

    } */
  }

  render () {
    const { showMenu, showReportMenu, showUser } = this.state
    const currentUser = authService.getCurrentUser()
    const { avatar, name, role, email } = currentUser
    const profilePicture = avatar !== '' ? `${apiHostname}${avatar}` : '/img/avatar-blank.png'

    const renderMenuGroup = (group) => {
      let hasChildMenu = false
      for (var i=0; i < group.menu.length; i++) {
        const menu = group.menu[i]

        if (this.canShowMenu(menu.permission)) {
          hasChildMenu = true
          break
        }
      }

      return hasChildMenu ? <div key={group.title}>
        <div className='title'>{ group.icon ? <Icon type={group.icon} /> : null } {group.title}</div>
        <div className='list'>
          {
            group.menu.map((menu, idx) => {
              const showMenu = this.canShowMenu(menu.permission)

              if (showMenu) {
                return menu.link && menu.link !== '' ? (
                  <Link to={menu.link} key={'menu' + idx}><div>{menu.name}{menu.status && menu.status > 0 ? (menu.status === 1 ? <span className={`label new`}>New</span> : menu.status === 2 ? <span className={`label old`}>Deprecated</span> : null) : null }</div></Link>
                ) : (
                  <div key={'menu' + idx}>{menu.name}</div>
                )
              }
            })
          }
        </div>
      </div> : null
    }

    const renderReportMenuGroup = (group) => {
      let hasChildMenu = false
      for (var i=0; i < group.menu.length; i++) {
        const menu = group.menu[i]

        if (this.canShowMenu(menu.permission)) {
          hasChildMenu = true
          break
        }
      }

      return hasChildMenu ? <div key={group.title}>
        <div className='title'>{ group.icon ? <Icon type={group.icon} /> : null } {group.title}</div>
        <div className='list'>
          {
            group.menu.map((menu, idx) => {
              const showMenu = this.canShowMenu(menu.permission)

              if (showMenu) {
                return menu.link && menu.link !== '' ? (
                  <Link to={menu.link} key={'rmenu' + idx}><div>{menu.name}{menu.status && menu.status > 0 ? (menu.status === 1 ? <span className={`label new`}>New</span> : menu.status === 2 ? <span className={`label old`}>Deprecated</span> : null) : null }</div></Link>
                ) : (
                  <div key={'rmenu' + idx}>{menu.name}</div>
                )
              }
            })
          }
        </div>
      </div> : null
    }

    return (
      <Router>
        <div className='app'>
          <div className='app-topbar' style={build === 'prod' ? null : build === 'uat' ? { backgroundImage: 'linear-gradient(to right bottom, #1d2c46, #aa1936)' } : { backgroundImage: 'linear-gradient(to right bottom, #1d2c46, #47702a)' }}>
            <div className='content'>
              <Link to='/'>
                <img alt='' src='/img/logo-flexi.png' className='app-logo' /> {build === 'prod' ? null : <span style={{ marginLeft: '2px', color: '#FFA501', fontSize: '8pt', letterSpacing: '1px' }}>{build || 'unknown'}</span>}
              </Link>

              <div className='menu-list'>
                {this.canShowMenu('listJobs') ? (
                  <Link className='menu' to='/jobs/list/single/future'>
                    <div onMouseOver={() => this.hideAllMenu()}>
                      <Icon type='thunderbolt' style={{color: 'orange'}} /> Jobs
                    </div>
                  </Link>
                ) : null}

                {this.canShowMenu('listClients') ? (
                  <Link className='menu' to='/clients'>
                    <div onMouseOver={() => this.hideAllMenu()}>
                      <Icon type='usergroup-add' style={{color: 'orange'}} /> Clients
                    </div>
                  </Link>
                ) : null}

                {this.canShowMenu('listFunders') ? (
                  <Link className='menu' to='/funders'>
                    <div onMouseOver={() => this.hideAllMenu()}>
                      <Icon type='team' style={{color: 'orange'}} /> Funders
                    </div>
                  </Link>
                ) : null}

                {this.canShowMenu('listEmployees') ? (
                  <Link className='menu' to='/employees'>
                    <div onMouseOver={() => this.hideAllMenu()}>
                      <Icon type='user' style={{color: 'orange'}} /> Employees
                    </div>
                  </Link>
                ) : null}

                {this.canShowMenu('listFeedbacks') ? (
                  <Link className='menu' to='/feedbacks'>
                    <div onMouseOver={() => this.hideAllMenu()}>
                      <Icon type='star' style={{color: 'orange'}} /> Feedbacks
                    </div>
                  </Link>
                ) : null}

                {this.canShowMenu('listMap') ? (
                  <Link className='menu' to='/map'>
                    <div onMouseOver={() => this.hideAllMenu()}>
                      <Icon type='global' style={{color: 'orange'}} /> Map
                    </div>
                  </Link>
                ) : null}

                {this.canShowMenu('listPayrolls') ? (
                  <Link className='menu' to='/payrolls'>
                    <div onMouseOver={() => this.hideAllMenu()}>
                      <Icon type='dollar' style={{color: 'orange'}} /> Payroll
                    </div>
                  </Link>
                ) : null}

                {this.canShowMenu('') ? (
                  <div className='menu' onClick={() => this.showReportMenu()}>
                    <Icon type='snippets' style={{color: 'orange'}} /> Reports <Icon type='down' className='App-expand-icon' />
                  </div>
                ) : null}

                {/* <Link className='menu' to='/communication'>
                  <div onMouseOver={() => this.hideAllMenu()}>
                    <Icon type='message' style={{color: 'orange'}} /> Comm.
                  </div>
                </Link> */}

                <div className='menu' onClick={() => this.showMenu()}>
                  <Icon type='down' className='App-expand-icon' />
                </div>

                {/* MS0076 - part 2 - Obsolete Notification screen */}
                {/* <Link className='menu' to='/notification'>
                  <div onMouseOver={() => this.hideAllMenu()} style={{ width: '28px' }}>
                    <Icon type='exclamation-circle' style={{color: 'orange'}} />
                  </div>
                </Link> */}

                <div className='menu' style={{width: '200px', textAlign: 'left', fontWeight: 'bold', fontSize: 11, padding: '0px 10px'}} onClick={this.showUserProfile} onMouseOver={() => this.hideAllMenu()}>
                  <Icon type='user' />&nbsp; {name} &nbsp;<Icon type='down' className='App-expand-icon' />
                </div>
              </div>

              <div className='hamburger' onClick={this.toggleMenu}> ☰ </div>
            </div>
          </div>

          <div className={'menu-popup' + (showMenu ? ' menu-popup-show' : ' menu-popup-hide')} onMouseOver={() => this.showMenu()} onMouseOut={() => this.hideMenu()}>
            {
              MainMenu.map((section, idx) => {
                return (
                  <div className='part' key={'part' + idx}>
                    {
                      section.groups.map((group, idx) => {
                        const showMenu = this.canShowMenu(group.permission, group.name)

                        return showMenu ? (
                          <div className='column' key={'column' + idx}>
                            {
                              group.subgroup ? (
                                this.canShowMenu(group.subgroup.permission, group.subgroup.name) ? (
                                  group.subgroup.map((subgroup) => (
                                    renderMenuGroup(subgroup)
                                  ))
                                ) : null
                              ) : renderMenuGroup(group)
                            }
                          </div>
                        ) : null
                      })
                    }
                  </div>
                )
              })
            }
          </div>

          <div className={'report-popup' + (showReportMenu ? ' report-popup-show' : ' report-popup-hide')} onMouseOver={() => this.showReportMenu()} onMouseOut={() => this.hideReportMenu()}>
            {
              ReportExpandMenu.map((section, idx) => {
                return (
                  <div className='part' key={'rpart' + idx}>
                    {
                      section.groups.map((group, idx) => {
                        const showMenu = this.canShowMenu(group.permission, group.name)

                        return showMenu ? (
                          <div className='column' key={'rcolumn' + idx}>
                            {
                              group.subgroup ? (
                                this.canShowMenu(group.subgroup.permission, group.subgroup.name) ? (
                                  group.subgroup.map((subgroup) => (
                                    renderReportMenuGroup(subgroup)
                                  ))
                                ) : null
                              ) : renderReportMenuGroup(group)
                            }
                          </div>
                        ) : null
                      })
                    }
                  </div>
                )
              })
            }
          </div>

          <div className='app-content'>
            {routes.map((route, idx) => (
              <Route
                key={'app-content' + idx}
                component={route.component}
                path={route.path}
                exact={route.exact}
              />
            ))}
          </div>

          <SideModal
            title='My Profile'
            showModal={showUser}
            onClose={this.hideUserProfile}
            buttons={[
              <Button key='logout' onClick={this.handleLogout}>Logout</Button>
            ]}
          >
            <img alt='' src='/img/user.png' className='app-user' />
            <div className='app-user-name'>{ name }</div>
          </SideModal>
        </div>
      </Router>
    )
  }

  canShowMenu = (permission, name) => {
    if (permission) {
      return authService.hasAccess(permission)
    }

    return true
  }

  handleLogout = async () => {
    const response = await authService.signOut()

    if (response) {
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = '/login'
    }
  }

  hideAllMenu = () => {
    this.setState({ showMenu: false, showReportMenu: false })
  }

  hideMenu = () => {
    this.setState({ showMenu: false })
  }

  hideReportMenu = () => {
    this.setState({ showReportMenu: false })
  }

  showMenu = () => {
    this.setState({ showMenu: true })
  }

  showReportMenu = () => {
    this.setState({ showReportMenu: true })
  }

  toggleMenu = () => {
    const { showMenu } = this.state
    this.setState({ showMenu: !showMenu })
    window.scrollTo(0, 0)
  }

  hideUserProfile = () => {
    this.setState({ showUser: false })
  }

  showUserProfile = () => {
    this.setState({ showUser: true })
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(App))
